const getUrlParameters = (query) => {
  if (!query) {
    return {};
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      let [key, value] = param.split('=');

      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';

      return params;
    }, {});
};

const getUrlParameterByName = (pName, query, returnAsArray) => {
  if (!query) {
    return undefined;
  }
  let pAll = getUrlParameters(query);
  //console.log('parameter name '+pName);
  let pValue = pAll[pName.toString()];
  //console.log('parameter value '+pValue);
  if(pName!=''&& pName.toLowerCase()=='itemid' && pValue!='' && pValue!==undefined){
    pValue=pValue.toLowerCase().replace("{", "").replace("}", "").replace("%7b","").replace("%7d","");
}

  if (!pValue) return undefined;

  if (returnAsArray) {
    let pValueSplit = pValue.split(',');
    if (pValueSplit.length > 1) {
      return pValueSplit;
    } else {
      let newArr = [];
      newArr.push(pValue);
      return newArr;
    }
  }

  return pValue;
};


module.exports = {
  getUrlParameters: getUrlParameters,
  getUrlParameterByName: getUrlParameterByName
};


// WEBPACK FOOTER //
// ./shared/scripts/UrlParameterHelper.js